import React from 'react';
import PortalShell from '@/components/portal/PortalShell';
import PublicHero from '@/components/portal/PublicHero';
import FeaturedProjects from '@/components/portal/FeaturedProjects';

// WP2.1B-R2: hero aligned to the locked Public Portal composition. The project
// listing continues to render through FeaturedProjects (contentService-driven).
const Projects: React.FC = () => {
  return (
    <PortalShell>
      <PublicHero
        badge="Opportunities"
        title={<>Active surveys &amp;<br /><span className="text-eds-mint">investment opportunities</span></>}
        subtitle="Explore active geological surveys and investment opportunities across all regions."
      />
      <FeaturedProjects />
    </PortalShell>
  );
};

export default Projects;
